export const isMobile = () => {
  // return true;
  // 宽度小于1440px的都认为是移动端
  // if (window.innerWidth < 1440) {
  //   return true;
  // }
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
export function uuid4V1() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
export function copyFormatText(val: string) {
  const el = document.createElement('textarea');
  el.style.whiteSpace = 'pre-wrap';

  el.value = val;

  document.body.appendChild(el);

  el.select();

  document.execCommand('copy');

  document.body.removeChild(el);
}